const whiteList = ['apps.apple.com']

export default whiteList
